import { forwardRef } from "react";
import type { TextareaProps } from "./interface";

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, ...props }, ref) => {
    return (
      <div className="flex flex-col gap-2">
        {label && <label className="font-semibold text-sm">{label}</label>}
        <textarea
          ref={ref}
          {...props}
          className={`border border-[#D8DCDE] text-sm py-3 px-4 rounded resize-vertical min-h-[100px] ${
            props.value ? "text-black" : "text-[#C2C8CC]"
          }`}
        />
      </div>
    );
  }
);
